import React, { FC } from 'react'
import styled from 'styled-components'
import { EBreakpoint } from 'src/styles/type'

export const HeaderShadowStyled = styled.div`
  background: linear-gradient(to bottom, rgb(0 0 0 / 3%), #ffffff 10px);
  position: absolute;
  width: 100%;
  height: 10px;
  @media screen and (max-width: ${EBreakpoint.MOBILE}) {
    display: none;
  }
`
const HeaderShadow: FC<{
  children: React.ReactNode
}> = ({ children }) => {
  return <HeaderShadowStyled>{children}</HeaderShadowStyled>
}

export default HeaderShadow
